export default __webpack_public_path__ + "static/media/close-vector.26af8d04.svg";